<template>
  <header id="header" v-if="showHeader">
    <div class="container-fluid">
      <div class="row" v-if="loginHeader === true">
        <div class="col-md-6 align-self-center">
        <div></div>
          <a href="#" class="logo position-relative">
            <img v-if="businessLogo" :src="businessLogo" style="width: 100px !important; height: 15px !important" /> 
           <!-- <img v-if="systemName" :src="`${urlServer}/files/${systemName}`" style="width: 70px !important; position: absolute; bottom: -15px; right: -50px" /> -->
          </a>
        </div>
        <div class="col-md-6 align-self-center">
          <!--
         
          <div class="select-languages">
           <div class="form">
             <select style="border-color: #fff !important;">
               <option value="English">English</option>
               <option value="Chines">Chinese</option>
               <option value="French">French</option>
             </select>
           </div>
            <div class="img-wrapper">
              <i class="fa-solid fa-circle-question"></i>
            </div>
          </div> -->
        </div>
      </div>

      <div class="header-main" v-if="mainHeader === true">
        <div class="header-top-row">
          <button type="button" class="header-hamburger" aria-label="Toggle menu" @click="toggleMobileNav">
            <i :class="['fas', mobileNavOpen ? 'fa-times' : 'fa-bars']"></i>
          </button>
          <div class="header-brand">
            <RouterLink to="/home" class="logo" @click="closeMobileNav">
              <img src="../assets/images/ppt/pavicon_login_ppt.png" alt="" class="logo-img">
             <!-- <span class="logo-title">{{ profile?.systemName ? profile.systemName : 'Inventory & W/H Management System' }}</span> -->
            </RouterLink>
          </div>
          <div class="header-user">
            <ul class="info">
              <li class="user-menu-container">
                <div class="user-dropdown">
                  <button class="user-trigger" @click="toggleUserMenu">
                    <span class="user-name">{{ user?.name }}</span>
                    <span class="caret">▾</span>
                  </button>
                  <ul v-if="userMenuOpen" class="user-dropdown-menu">
                    <li @click="goToProfile">Profile</li>
                    <!--<li class="user-toggle" @click.stop="toggleDarkMode">
                      <span>{{ isDarkMode ? 'Dark' : 'Light' }} mode</span>
                      <input type="checkbox" :checked="isDarkMode" readonly />
                    </li>-->
                    <li @click="logout">Log Out</li>
                  </ul>
                </div>
              </li>
              <li>
                <div class="bell-icon" style="position: relative; cursor: pointer;" @click="showNotifications">
                  <img src="../assets/images/icons/bell1.png" style="width: 25px !important; height: auto !important;" alt="Notifications">
                  <span  class="counter notification-badge" @click.stop="$router.push('/settings/approvals')">
                    {{ countPendingApprovals(approvals) }}
                  </span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <template v-if="mainHeader === true">
        <div v-if="mobileNavOpen" class="header-nav-backdrop" @click="closeMobileNav"></div>
        <div class="header-nav" :class="{ 'mobile-open': mobileNavOpen }">
          <ul class="menu main-nav" v-if="!isBusinessDevelopmentMode" @click="closeMobileNavOnLink">
            <li v-if="user?.Permission?.dashboard"><RouterLink to="/home">Home</RouterLink></li>
            <li v-if="user?.Permission?.transaction" :class="{ 'nav-dropdown-open': openDropdownId === 3 }" @mouseenter="showDropdown(3)" @mouseleave="hideDropdown(3)">
              <a href="#" @click.prevent="menuDropdown3">Transactions
                <svg fill="#000000" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
                width="20px" height="20px" viewBox="0 0 100 100" enable-background="new 0 0 100 100" xml:space="preserve">
                  <g>
                    <path d="M78.466,35.559L50.15,63.633L22.078,35.317c-0.777-0.785-2.044-0.789-2.828-0.012s-0.789,2.044-0.012,2.827L48.432,67.58
                      c0.365,0.368,0.835,0.563,1.312,0.589c0.139,0.008,0.278-0.001,0.415-0.021c0.054,0.008,0.106,0.021,0.16,0.022
                      c0.544,0.029,1.099-0.162,1.515-0.576l29.447-29.196c0.785-0.777,0.79-2.043,0.012-2.828S79.249,34.781,78.466,35.559z"/>
                  </g>
                </svg>
            </a>
              <ul class="menu menu-dropdown" :style="menuDropdownStyle3" >
                <li><RouterLink to="/transaction">BPN Transactions</RouterLink></li>
                <li><RouterLink to="/transaction/incompletenotes">Incomplete Delivery Notes</RouterLink></li>
              </ul>
            </li>
            <li :class="{ 'nav-dropdown-open': openDropdownId === 2 }" @mouseenter="showDropdown(2)" @mouseleave="hideDropdown(2)">
              <a href="#" @click.prevent="menuDropdown2">Inventory
                <svg fill="#000000" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
                width="20px" height="20px" viewBox="0 0 100 100" enable-background="new 0 0 100 100" xml:space="preserve">
                  <g>
                    <path d="M78.466,35.559L50.15,63.633L22.078,35.317c-0.777-0.785-2.044-0.789-2.828-0.012s-0.789,2.044-0.012,2.827L48.432,67.58
                      c0.365,0.368,0.835,0.563,1.312,0.589c0.139,0.008,0.278-0.001,0.415-0.021c0.054,0.008,0.106,0.021,0.16,0.022
                      c0.544,0.029,1.099-0.162,1.515-0.576l29.447-29.196c0.785-0.777,0.79-2.043,0.012-2.828S79.249,34.781,78.466,35.559z"/>
                  </g>
                </svg>
              </a>
              <ul class="menu menu-dropdown" :style="menuDropdownStyle2" >
                <li><RouterLink to="/inventory/stocks">Manage Stock Levels</RouterLink></li>
                <li class="mt-1"><RouterLink to="/inventory/stocks/markedreturn">Manage Returns</RouterLink></li>
                <li class="mt-2"><RouterLink to="/warehouses/locate">Locate Product</RouterLink></li>
                <li class="mt-1"><RouterLink to="/inventory/products">View Products</RouterLink></li>
                <li class="mt-1"><RouterLink to="/inventory/products/add">Add Product</RouterLink></li>
                <li class="mt-1"><RouterLink to="/inventory/stocks/adjustments">Stock Adjustment</RouterLink></li>
                <li class="mt-1"><RouterLink to="/inventory/stocks/transfers">Stock Transfer</RouterLink></li>
                <li class="mt-1"><RouterLink to="/inventory/stocks/reserveds">Stock Reserve</RouterLink></li>
              </ul>
            </li>
            <li :class="{ 'nav-dropdown-open': openDropdownId === 4 }" @mouseenter="showDropdown(4)" @mouseleave="hideDropdown(4)">
              <a href="#" @click.prevent="menuDropdown4">Warehouse
                <svg fill="#000000" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
                width="20px" height="20px" viewBox="0 0 100 100" enable-background="new 0 0 100 100" xml:space="preserve">
                  <g>
                    <path d="M78.466,35.559L50.15,63.633L22.078,35.317c-0.777-0.785-2.044-0.789-2.828-0.012s-0.789,2.044-0.012,2.827L48.432,67.58
                      c0.365,0.368,0.835,0.563,1.312,0.589c0.139,0.008,0.278-0.001,0.415-0.021c0.054,0.008,0.106,0.021,0.16,0.022
                      c0.544,0.029,1.099-0.162,1.515-0.576l29.447-29.196c0.785-0.777,0.79-2.043,0.012-2.828S79.249,34.781,78.466,35.559z"/>
                  </g>
                </svg>
              </a>
              <ul class="menu menu-dropdown" :style="menuDropdownStyle4" >
                <li v-if="user?.Permission?.batchAdd"><RouterLink to="/transaction/addbatch">Add Stock/Batch Processing</RouterLink></li>
                <li class="mt-1"><RouterLink to="/warehouses/locate">Locate Product</RouterLink></li>
                <li class="mt-1"><RouterLink to="/inventory/stocks/markedreturn">Manage Returns</RouterLink></li>
                <li v-if="user?.Permission?.warehouseView" class="mt-1"><RouterLink to="/warehouses">View Warehouses</RouterLink></li>
                <li v-if="user?.Permission?.warehouseAdd" class="mt-1"><RouterLink to="/warehouses/add">Add Warehouse</RouterLink></li> 
                <li v-if="user?.Permission?.warehouseManage" class="mt-1"><RouterLink to="/warehouses/virtual">Manage Virtual Warehouses</RouterLink></li>
              </ul>
            </li>
            <li :class="{ 'nav-dropdown-open': openDropdownId === 5 }" @mouseenter="showDropdown(5)" @mouseleave="hideDropdown(5)">
              <a href="#" @click.prevent="menuDropdown5">Purchases
                <svg fill="#000000" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
                width="20px" height="20px" viewBox="0 0 100 100" enable-background="new 0 0 100 100" xml:space="preserve">
                  <g>
                    <path d="M78.466,35.559L50.15,63.633L22.078,35.317c-0.777-0.785-2.044-0.789-2.828-0.012s-0.789,2.044-0.012,2.827L48.432,67.58
                      c0.365,0.368,0.835,0.563,1.312,0.589c0.139,0.008,0.278-0.001,0.415-0.021c0.054,0.008,0.106,0.021,0.16,0.022
                      c0.544,0.029,1.099-0.162,1.515-0.576l29.447-29.196c0.785-0.777,0.79-2.043,0.012-2.828S79.249,34.781,78.466,35.559z"/>
                  </g>
                </svg>
              </a>
              <ul class="menu menu-dropdown" :style="menuDropdownStyle5" >
                <li v-if="user?.Permission?.purchaseRequestAdd" class="mt-1"><RouterLink to="/transaction/purchase-request/add">Purchase Requisition</RouterLink></li>
                <li><RouterLink to="/transaction/purchase-request">Manage Purchase Requests</RouterLink></li>
                <li v-if="user?.Permission?.purchaseView"><RouterLink to="/purchases">Manage Purchase Orders</RouterLink></li>
                <li v-if="user?.Permission?.purchaseAdd" class="mt-1"><RouterLink to="/purchases/add">Add Purchase Orders</RouterLink></li>
                <li v-if="user?.Permission?.purchaseAdd" class="mt-1 fw-bold border-top pt-1"><RouterLink to="/settings/approvals/awaiting" class="text-primary">Approvals Tracking</RouterLink></li>
              </ul>
            </li>
            <li v-if="user?.Permission?.supplierView" :class="{ 'nav-dropdown-open': openDropdownId === 6 }" @mouseenter="showDropdown(6)" @mouseleave="hideDropdown(6)">
              <a href="#" @click.prevent="menuDropdown6">Suppliers
                <svg fill="#000000" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
                width="20px" height="20px" viewBox="0 0 100 100" enable-background="new 0 0 100 100" xml:space="preserve">
                  <g>
                    <path d="M78.466,35.559L50.15,63.633L22.078,35.317c-0.777-0.785-2.044-0.789-2.828-0.012s-0.789,2.044-0.012,2.827L48.432,67.58
                      c0.365,0.368,0.835,0.563,1.312,0.589c0.139,0.008,0.278-0.001,0.415-0.021c0.054,0.008,0.106,0.021,0.16,0.022
                      c0.544,0.029,1.099-0.162,1.515-0.576l29.447-29.196c0.785-0.777,0.79-2.043,0.012-2.828S79.249,34.781,78.466,35.559z"/>
                  </g>
                </svg>
              </a>
              <ul class="menu menu-dropdown" :style="menuDropdownStyle6" >
                <li v-if="user?.Permission?.supplierView"><RouterLink to="/suppliers">Manage Suppliers</RouterLink></li>
                <li v-if="user?.Permission?.supplierAdd" class="mt-1"><RouterLink to="/suppliers/add">Add Suppliers</RouterLink></li>
                <li v-if="user?.Permission?.supplierAdd" class="mt-1"><RouterLink to="/suppliers/bulk">Bulk Upload Suppliers</RouterLink></li>
                <li v-if="user?.Permission?.supplierAdd" class="mt-1"><RouterLink to="/suppliers/tender-categories/add">Procurement Categories</RouterLink></li>
              </ul>
            </li>
            <li :class="{ 'nav-dropdown-open': openDropdownId === 1 }" @mouseenter="showDropdown(1)" @mouseleave="hideDropdown(1)">
              <a href="#" @click.prevent="menuDropdown1">Orders
                <svg fill="#000000" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
                width="20px" height="20px" viewBox="0 0 100 100" enable-background="new 0 0 100 100" xml:space="preserve">
                  <g>
                    <path d="M78.466,35.559L50.15,63.633L22.078,35.317c-0.777-0.785-2.044-0.789-2.828-0.012s-0.789,2.044-0.012,2.827L48.432,67.58
                      c0.365,0.368,0.835,0.563,1.312,0.589c0.139,0.008,0.278-0.001,0.415-0.021c0.054,0.008,0.106,0.021,0.16,0.022
                      c0.544,0.029,1.099-0.162,1.515-0.576l29.447-29.196c0.785-0.777,0.79-2.043,0.012-2.828S79.249,34.781,78.466,35.559z"/>
                  </g>
                </svg>
              </a>
              <ul class="menu menu-dropdown" :style="menuDropdownStyle1" >
                <li><RouterLink to="/orders">Manage Orders</RouterLink></li>
                <li v-if="user?.Permission?.dispatchProcess"><RouterLink to="/orders/process">Process Orders</RouterLink></li>
                <li v-else><RouterLink to="/orders">View  Orders</RouterLink></li>
                <li v-if="user?.Permission?.pickupAdd" class="mt-1"><RouterLink to="/orders/pickup/add">Create Order - Pickup Note</RouterLink></li>
                <li v-if="user?.Permission?.dispatchAdd" class="mt-1"><RouterLink to="/orders/dispatch/add">Generate Dispatch Order</RouterLink></li>
                <li class="mt-1"><RouterLink to="/orders/cancelled">View Cancelled Orders</RouterLink></li>
              </ul>
            </li>
            <li v-if="user?.Permission?.purchaseAdd">
              <RouterLink to="/settings/services">Services</RouterLink>
            </li>
            <li v-if="user?.Permission?.dashboard && user?.Permission?.tenderManage" :class="{ 'nav-dropdown-open': openDropdownId === 7 }" @mouseenter="showDropdown(7)" @mouseleave="hideDropdown(7)">
              <a href="#" @click.prevent="menuDropdown7">Tenders
                <svg fill="#000000" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
                width="20px" height="20px" viewBox="0 0 100 100" enable-background="new 0 0 100 100" xml:space="preserve">
                  <g>
                    <path d="M78.466,35.559L50.15,63.633L22.078,35.317c-0.777-0.785-2.044-0.789-2.828-0.012s-0.789,2.044-0.012,2.827L48.432,67.58
                      c0.365,0.368,0.835,0.563,1.312,0.589c0.139,0.008,0.278-0.001,0.415-0.021c0.054,0.008,0.106,0.021,0.16,0.022
                      c0.544,0.029,1.099-0.162,1.515-0.576l29.447-29.196c0.785-0.777,0.79-2.043,0.012-2.828S79.249,34.781,78.466,35.559z"/>
                  </g>
                </svg>
              </a>
              <ul class="menu menu-dropdown" :style="menuDropdownStyle7" >
                <li><RouterLink to="/admin/procurement/analytics">Overview</RouterLink></li>
                <li class="mt-1"><RouterLink to="/admin/tenders/add">Request Quotations / Add Tender</RouterLink></li>
                <li class="mt-1"><RouterLink to="/admin/tenders">Manage Quotation Requests</RouterLink></li>
                <li class="mt-1"><RouterLink to="/admin/tenders/submissions">Submitted Quotations </RouterLink></li>
                <li class="mt-1"><RouterLink to="/admin/tenders/submissions?status=AWARDED">Awarded Contracts</RouterLink></li>
                <li class="mt-1"><RouterLink to="/admin/email-logs">Email Logs</RouterLink></li>
              </ul>
            </li>
            
            <li v-if="user?.Permission?.dispatchProcess" :class="{ 'nav-dropdown-open': openDropdownId === 8 }" @mouseenter="showDropdown(8)" @mouseleave="hideDropdown(8)">
              <a href="#" @click.prevent="menuDropdown8">Fleet
                <svg fill="#000000" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
                width="20px" height="20px" viewBox="0 0 100 100" enable-background="new 0 0 100 100" xml:space="preserve">
                  <g>
                    <path d="M78.466,35.559L50.15,63.633L22.078,35.317c-0.777-0.785-2.044-0.789-2.828-0.012s-0.789,2.044-0.012,2.827L48.432,67.58
                      c0.365,0.368,0.835,0.563,1.312,0.589c0.139,0.008,0.278-0.001,0.415-0.021c0.054,0.008,0.106,0.021,0.16,0.022
                      c0.544,0.029,1.099-0.162,1.515-0.576l29.447-29.196c0.785-0.777,0.79-2.043,0.012-2.828S79.249,34.781,78.466,35.559z"/>
                  </g>
                </svg>
              </a>
              <ul class="menu menu-dropdown" :style="menuDropdownStyle8" >
                <li><RouterLink to="/fleet">Overview</RouterLink></li>
                <li class="mt-1"><RouterLink to="/fleet/vehicles">Vehicles</RouterLink></li>
                <li class="mt-1"><RouterLink to="/fleet/drivers">Drivers</RouterLink></li>
                <li class="mt-1"><RouterLink to="/fleet/trips">Trips</RouterLink></li>
                <li class="mt-1"><RouterLink to="/fleet/fuel">Fuel Requests</RouterLink></li>
                <li class="mt-1"><RouterLink to="/fleet/compliance">Compliance</RouterLink></li>
                <li class="mt-1"><RouterLink to="/fleet/maintenance">Scheduled Maintenance</RouterLink></li>
                <li class="mt-1"><RouterLink to="/fleet/driver-assignments">Driver Assignments</RouterLink></li>
                <li class="mt-1"><RouterLink to="/fleet/settings">Fleet Configs</RouterLink></li>
              </ul>
            </li>

            <li :class="{ 'nav-dropdown-open': openDropdownId === 9 }" @mouseenter="showDropdown(9)" @mouseleave="hideDropdown(9)">
              <a href="#" @click.prevent="menuDropdown9">Reports
                <svg fill="#000000" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
                width="20px" height="20px" viewBox="0 0 100 100" enable-background="new 0 0 100 100" xml:space="preserve">
                  <g>
                    <path d="M78.466,35.559L50.15,63.633L22.078,35.317c-0.777-0.785-2.044-0.789-2.828-0.012s-0.789,2.044-0.012,2.827L48.432,67.58
                      c0.365,0.368,0.835,0.563,1.312,0.589c0.139,0.008,0.278-0.001,0.415-0.021c0.054,0.008,0.106,0.021,0.16,0.022
                      c0.544,0.029,1.099-0.162,1.515-0.576l29.447-29.196c0.785-0.777,0.79-2.043,0.012-2.828S79.249,34.781,78.466,35.559z"/>
                  </g>
                </svg>
              </a>
              <ul class="menu menu-dropdown" :style="menuDropdownStyle9" >
                <li><RouterLink to="/reports/procurement">Procurement</RouterLink></li>
                <li class="mt-1"><RouterLink to="/reports">General</RouterLink></li>
              </ul>
            </li>

            <li v-if="user?.Permission?.usersAdd"><RouterLink to="/settings">Settings</RouterLink></li>
          </ul>
        </div>
    </template>
  </header>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { useDarkMode } from '../composables/useDarkMode'

export default {
  name: 'FooterComponent',
  props: ['loginHeader', 'mainHeader'],
  setup() {
    const { isDarkMode, toggleDarkMode } = useDarkMode()
    return {
      isDarkMode,
      toggleDarkMode
    }
  },
  data: () => {
    let initialUser = null
    try {
      const cached = localStorage.getItem('user_cache')
      if (cached) {
        initialUser = JSON.parse(cached)
      } else {
        const perm = localStorage.getItem('permission')
        if (perm) {
          initialUser = { Permission: JSON.parse(perm) }
        }
      }
    } catch (e) { /* ignore */ }
    return {
    token: localStorage.getItem('access_token') ? JSON.parse(localStorage.getItem('access_token')) : null,
    user: initialUser || "",
    
    menuDropdownShow1: false,
    menuDropdownShow2: false,
    menuDropdownShow3: false,
    menuDropdownShow4: false,
    menuDropdownShow5: false,
    menuDropdownShow6: false,
    menuDropdownShow7: false,
    menuDropdownShow8: false,
    menuDropdownShow9: false,
    menuDropdownStyle1: null,
    menuDropdownStyle2: null,
    menuDropdownStyle3: null,
    menuDropdownStyle4: null,
    menuDropdownStyle5: null,
    menuDropdownStyle6: null,
    menuDropdownStyle7: null,
    menuDropdownStyle8: null,
    menuDropdownStyle9: null,
    menuDropData:{
      display: 'grid',
      background: '#fff', 
      position: 'absolute',
      'list-style': 'grid',
      padding: '11px 16px',
      'margin-left': '0',
      'margin-top': '4px',
      'border-radius': '5px',
      'border':'1px solid #d2d2d2',
      opacity: '1',
      transform: 'translateY(0)',
      visibility: 'visible',
      pointerEvents: 'auto',
      'z-index': 2,
    },
    menuDropDataHidden:{
      // IMPORTANT: keep hidden dropdowns out of layout.
      // On mobile we render dropdowns as `position: static`, so using opacity/visibility alone
      // would leave large blank gaps and push later menu items off-screen.
      display: 'none',
      background: '#fff', 
      position: 'absolute',
      'list-style': 'grid',
      padding: '11px 16px',
      'margin-left': '0',
      'margin-top': '4px',
      'border-radius': '5px',
      'border':'1px solid #d2d2d2',
      opacity: '0',
      transform: 'translateY(-6px)',
      visibility: 'hidden',
      pointerEvents: 'none',
      'z-index': 2,
    },
    businessLogo: "",
    systemName: "",
    urlServer:process.env.VUE_APP_URL,
    userMenuOpen: false,
    approvalsInterval: null,
    mobileNavOpen: false,
    openDropdownId: null,
  }
},


  computed:{
    ... mapGetters (["getApprovals", "getProfile"]),
    approvals () { return this.getApprovals },
    profile() { return this.getProfile },
    showHeader() {
      return !this.$route?.meta?.public;
    },
    isBusinessDevelopmentMode() {
      const path = this.$route?.path || ''
      const active = localStorage.getItem('active_module') || ''
      return active === 'business-development' || path.startsWith('/admin/bid')
    },
    hasBDAccess() {
      const p = this.user?.Permission
      if (!p) return false
      if (p.approveAll) return true
      return !!(p.bdOpportunitiesManage || p.bdBidPreparation || p.bdSubmissionTracking ||
        p.bdQualificationInput || p.bdContractHandover || p.canApproveBidOpportunity)
    },
  }, 

  methods: {
    ... mapActions(['fetchApprovals', 'fetchProfile']),
    isMobileViewport() {
      try { return typeof window !== 'undefined' && window.innerWidth < 992 } catch (e) { return false }
    },
    getDropdownStyle(isOpen) {
      // Desktop uses absolutely-positioned dropdowns; mobile uses static accordion-style lists.
      if (this.isMobileViewport()) {
        return isOpen
          ? {
              display: 'block',
              position: 'static',
              opacity: '1',
              visibility: 'visible',
              transform: 'none',
              pointerEvents: 'auto',
            }
          : {
              display: 'none',
              position: 'static',
              opacity: '0',
              visibility: 'hidden',
              transform: 'none',
              pointerEvents: 'none',
            }
      }
      return isOpen ? this.menuDropData : this.menuDropDataHidden
    },
    toggleMobileNav() {
      this.mobileNavOpen = !this.mobileNavOpen;
      if (this.mobileNavOpen) document.body.classList.add('mobile-nav-open');
      else document.body.classList.remove('mobile-nav-open');
    },
    closeMobileNav() {
      this.mobileNavOpen = false;
      document.body.classList.remove('mobile-nav-open');
    },
    closeMobileNavOnLink(e) {
      if (e.target.closest('a[href]') && !e.target.closest('a[href="#"]')) {
        this.closeMobileNav();
      }
    },
    showDropdown(n) {
      if (this._hideDropdownTimer) {
        clearTimeout(this._hideDropdownTimer);
        this._hideDropdownTimer = null;
      }
      this.resetDropdowns();
      this.openDropdownId = n;
      this['menuDropdownStyle' + n] = this.getDropdownStyle(true);
    },
    hideDropdown(n) {
      this._hideDropdownTimer = setTimeout(() => {
        this['menuDropdownStyle' + n] = this.getDropdownStyle(false);
        this.openDropdownId = null;
        this._hideDropdownTimer = null;
      }, 150);
    },
    menuDropdown1 () { 
      this.resetDropdowns()
      this.menuDropdownShow1 = !this.menuDropdownShow1;
      this.menuDropdownStyle1 = this.getDropdownStyle(!!this.menuDropdownShow1)
    },
    menuDropdown2 () { 
      this.resetDropdowns()
      this.menuDropdownShow2 = !this.menuDropdownShow2;
      this.menuDropdownStyle2 = this.getDropdownStyle(!!this.menuDropdownShow2)
    },
    menuDropdown3 () { 
      this.resetDropdowns()
      this.menuDropdownShow3 = !this.menuDropdownShow3;
      this.menuDropdownStyle3 = this.getDropdownStyle(!!this.menuDropdownShow3)
    },
    menuDropdown4 () { 
      this.resetDropdowns()
      this.menuDropdownShow4 = !this.menuDropdownShow4;
      this.menuDropdownStyle4 = this.getDropdownStyle(!!this.menuDropdownShow4)
    },
    menuDropdown5 () { 
      this.resetDropdowns()
      this.menuDropdownShow5 = !this.menuDropdownShow5;
      this.menuDropdownStyle5 = this.getDropdownStyle(!!this.menuDropdownShow5)
    },
    menuDropdown6 () { 
      this.resetDropdowns()
      this.menuDropdownShow6 = !this.menuDropdownShow6;
      this.menuDropdownStyle6 = this.getDropdownStyle(!!this.menuDropdownShow6)
    },
    menuDropdown7 () { 
      this.resetDropdowns()
      this.menuDropdownShow7 = !this.menuDropdownShow7;
      this.menuDropdownStyle7 = this.getDropdownStyle(!!this.menuDropdownShow7)
    },
    menuDropdown8 () { 
      this.resetDropdowns()
      this.menuDropdownShow8 = !this.menuDropdownShow8;
      this.menuDropdownStyle8 = this.getDropdownStyle(!!this.menuDropdownShow8)
    },
    menuDropdown9 () { 
      this.resetDropdowns()
      this.menuDropdownShow9 = !this.menuDropdownShow9;
      this.menuDropdownStyle9 = this.getDropdownStyle(!!this.menuDropdownShow9)
    },
    resetDropdowns(){
      const h = this.getDropdownStyle(false)
      this.menuDropdownStyle1 = h
      this.menuDropdownStyle2 = h
      this.menuDropdownStyle3 = h
      this.menuDropdownStyle4 = h
      this.menuDropdownStyle5 = h
      this.menuDropdownStyle6 = h
      this.menuDropdownStyle7 = h
      this.menuDropdownStyle8 = h
      this.menuDropdownStyle9 = h
      this.openDropdownId = null
    },

    showNotifications() {
      // TODO: Implement notification logic (open dropdown, modal, etc.)
      alert('Show notifications here');
    },
    async setupUser(){
        const requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json", 'Authorization': 'Bearer '+this.token },
        };
        const res = await fetch(process.env.VUE_APP_URL+'/users/profile', requestOptions)
        const data = await res.json()
        if(data.status == true){
          this.user = data.user;
          localStorage.setItem('permission', JSON.stringify(data.user.Permission))
          localStorage.setItem('userId', JSON.stringify(data.user.id))
          try {
            localStorage.setItem('user_cache', JSON.stringify({ name: data.user.name, Permission: data.user.Permission }))
          } catch (e) { /* ignore */ }
        }else{
          this.$router.push("/")
        }
    },
    toggleUserMenu() {
      this.userMenuOpen = !this.userMenuOpen
    },
    goToProfile() {
      this.userMenuOpen = false
      this.$router.push('/settings/profile')
    },
    logout() {
      this.userMenuOpen = false
      try { localStorage.removeItem('user_cache') } catch (e) { /* ignore */ }
      this.$router.push('/')
    },
  },
  created() {
    this.resetDropdowns();
  },
  async mounted(){
    //const profileData = localStorage.getItem('profile');
    //this.profile = profileData && profileData !== 'undefined' ? JSON.parse(profileData) : null;
    this.businessLogo = this.profile?.businessLogo
    this.systemName = this.profile?.systemName
    // Avoid running protected setup on public routes (prevents accidental redirects)
    const isPublicRoute = this.$route?.meta?.public || this.$route?.name === 'ResetPassword' || (typeof window !== 'undefined' && window.location && window.location.pathname === '/reset-password');
    if (isPublicRoute) return;
    // Only fetch protected data when not on a public route and when a token exists in localStorage
    try {
      const currentToken = localStorage.getItem('access_token') ? JSON.parse(localStorage.getItem('access_token')) : null;
      this.token = currentToken;

      if (this.token) {
        await this.setupUser()
        await this.fetchApprovals()
        await this.fetchProfile()

        console.log('Header mounted', this.profile);
        // start polling approvals every 5 minutes
        try {
          this.approvalsInterval = setInterval(() => {
            this.fetchApprovals().catch(e => console.error('Failed to poll approvals', e));
          }, 5 * 60 * 1000); // 5 minutes
        } catch (e) {
          console.error('Failed to start approvals polling', e);
        }
      }
    } catch (e) {
      // ignore parse errors and avoid blocking mount
    }
  },
  beforeUnmount() {
    if (this.approvalsInterval) {
      clearInterval(this.approvalsInterval);
      this.approvalsInterval = null;
    }
  },
  watch:{
    $route() {
      this.resetDropdowns();
      this.userMenuOpen = false;
      this.mobileNavOpen = false;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.info li{
  margin-right: 10px !important;
}

.info{
  padding: 10px !important;
}
.menu-dropdown li,a{
  color: #000 !important;
  cursor: pointer;
  opacity: 0.9;
}
.menu-dropdown li {
  padding: 2px 16px;
}
.menu-dropdown li.mt-1 {
  margin-top: 2px !important;
}
.menu-dropdown{
  margin-top: 4px !important;
  min-width: 260px;
  row-gap: 2px;
  transition: opacity 0.2s ease-out, transform 0.2s ease-out;
}

.menu-dropdown li:hover{
  background-color: #ffe0b2;
}

.user-menu-container { position: relative; }
.user-dropdown { position: relative; }
.user-trigger { background: transparent; border: none; color: inherit; cursor: pointer; font-size: 13px; display:inline-flex; align-items:center; gap:6px; }
.user-name { font-weight: 600; }
.user-dropdown-menu { position: absolute; right: 0; top: 28px; background: #fff; list-style: none; padding: 8px 0; margin: 0; border: 1px solid #d2d2d2; border-radius: 4px; min-width: 120px; z-index: 50; }
.user-dropdown-menu li { padding: 8px 11px; cursor: pointer; color: #000; }
.user-dropdown-menu li:hover { background: #f2f2f2 }

.user-toggle{ display:flex; align-items:center; justify-content:space-between; padding:8px 11px; }
.user-toggle input{ pointer-events:none }

.bell-icon {
  overflow: visible;
  flex-shrink: 0;
}

.notification-badge {
  position: absolute;
  top: -4px;
  right: -4px;
  min-width: 22px;
  height: 22px;
  background: #e74c3c;
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: bold;
  cursor: pointer;
  z-index: 10;
  box-shadow: 0 0 2px #333;
  padding: 0 6px;
}

/* Make header fixed so sidebars can sit below it */
#header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: #fff;
  /*box-shadow: 0 0px 0 rgba(134, 134, 134, 0.08);*/
  overflow: visible;
}

#header .main-header { display:flex; align-items:center; height:60px }

/* Header: top row (logo + user), nav row below */
.header-main {
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow: visible;
}
.header-top-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0px;
  gap: 6px;
}
.header-brand {
  flex-shrink: 0;
}
.header-brand .logo {
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0;
  text-decoration: none;
  color: inherit;
}
.header-brand .logo-img {
  max-width: 92px;
  max-height: 20px;
  width: auto;
  height: auto;
}
.header-brand .logo-title {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #000;
}
#header .header-nav {
  width: 100%;
  border-top: 1px solid rgba(0,0,0,0.04);
  padding: 0 12px;
  overflow: visible !important;
}
#header .header-nav .main-nav {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 2px 14px;
  list-style: none;
  margin: 0;
  padding: 7px 5px;
  overflow: visible !important;
}
.header-nav .main-nav > li {
  position: relative;
}
@media (min-width: 992px) {
  .header-nav .main-nav > li.nav-dropdown-open {
    padding-bottom: 260px;
    margin-bottom: -260px;
  }
}
/* Ensure dropdowns are visible above content and not clipped */
.header-nav .menu-dropdown {
  position: absolute;
  z-index: 1050;
}
.header-user {
  flex-shrink: 0;
}
.header-user .info {
  display: flex;
  align-items: center;
  list-style: none;
  margin: 0;
  padding: 0;
  gap: 11px;
}

/* Mobile hamburger - hidden on desktop */
.header-hamburger {
  display: none;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 1.25rem;
  color: inherit;
  flex-shrink: 0;
}

/* Mobile nav backdrop — dims content below the fixed top bar */
.header-nav-backdrop {
  display: none;
  position: fixed;
  left: 0;
  right: 0;
  top: var(--app-header-height, 60px);
  bottom: 0;
  width: 100vw;
  background: rgba(0, 0, 0, 0.45);
  z-index: 1001;
}

@media (max-width: 991px) {
  .header-hamburger { display: flex; }
  .header-nav-backdrop { display: block; }
  .header-top-row {
    padding: 8px 10px 6px;
    gap: 8px;
    min-height: 52px;
  }
  .header-brand {
    flex: 1 1 auto;
    min-width: 0;
    display: flex;
    justify-content: center;
  }
  .header-brand .logo-title {
    max-width: 140px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .header-nav {
    position: fixed;
    top: var(--app-header-height, 60px);
    left: 0 !important;
    right: 0 !important;
    width: 100vw !important;
    max-width: 100vw !important;
    margin: 0 !important;
    padding: 0 !important;
    box-sizing: border-box;
    bottom: auto;
    max-height: 0;
    height: auto;
    overflow: hidden;
    background: #fff;
    border-top: 1px solid rgba(0,0,0,0.08);
    box-shadow: 0 4px 12px rgba(0,0,0,0.12);
    z-index: 1002;
    transition: max-height 0.35s ease;
    /* Drawer stacks links from the top — never space-between (which caused huge gaps). */
    display: none;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    /* When closed: ensure nothing "bleeds" onto the page */
    visibility: hidden;
    pointer-events: none;
  }
  .header-nav.mobile-open {
    display: flex;
    /* Full-area panel below the header (entire width × remaining viewport height) */
    max-height: calc(100vh - var(--app-header-height, 60px));
    min-height: calc(100vh - var(--app-header-height, 60px));
    height: calc(100vh - var(--app-header-height, 60px));
    padding-bottom: env(safe-area-inset-bottom, 0px);
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: contain;
    visibility: visible;
    pointer-events: auto;
  }
  .header-nav .main-nav {
    flex-direction: column;
    align-items: stretch !important;
    align-content: flex-start !important;
    justify-content: flex-start !important;
    flex-wrap: nowrap !important;
    padding: 8px 16px 16px;
    gap: 0 !important;
    width: 100%;
    min-height: 0 !important;
    height: auto !important;
    flex: 0 0 auto !important;
  }
  .header-nav .main-nav > li {
    flex: 0 0 auto !important;
    border-bottom: 0.5px solid #eee;
  }
  .header-nav .main-nav > li:last-child { border-bottom: none; }
  .header-nav .main-nav a {
    display: block;
    padding: 12px 12px;
    text-align: left;
  }
  .header-nav .menu-dropdown {
    position: static !important;
    margin-top: 0 !important;
    margin-left: 0 !important;
    padding: 0 0 8px 16px !important;
    border: none !important;
    box-shadow: none !important;
    min-width: auto !important;
  }
  .header-nav .menu-dropdown li { padding: 6px 0; }
}

@media (max-width: 576px) {
  .header-brand .logo-title { max-width: 100px; }
  .user-name { max-width: 80px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
}

</style>
